export { cardBackdrops, columnBackdrops, NEUTRAL_COLUMN, NEUTRAL_SURFACE } from './contrast';
export {
  backgroundStyle,
  columnLook,
  coverStyle,
  gradientCss,
  gradientText,
  hexToRgba,
  isHex,
  lookProps,
  mixHex,
  patternLayer,
} from './css';
export {
  DEFAULT_PATTERN,
  GRADIENT_ANGLES,
  GRADIENT_PRESETS,
  patternOf,
  STANDARD_LOOK,
} from './presets';
export { MIN_IMAGE_OVERLAY, surfaceProps, type SurfaceImage, type SurfaceProps } from './surface';
export { cardLookSource, effectiveCardLook } from './resolve';
export {
  BACKGROUND_KINDS,
  LOOK_STYLES,
  PATTERN_IDS,
  type AdvancedColors,
  type Background,
  type BackgroundKind,
  type BoardAppearance,
  type ColumnLookExtra,
  type Cover,
  type CoverInput,
  type Gradient,
  type Look,
  type LookStyle,
  type Pattern,
  type PatternId,
  SURFACE_KINDS,
  type SurfaceFill,
  type SurfaceKind,
  type WorkspaceAppearance,
} from './types';
import lookStyles from './look.module.css';

/** Class that makes an element a look surface (use together with `lookProps()`). */
export const lookSurface = lookStyles.surface;
